const selectBase = state => state.onboarding.channels

export const selectIsFacebookConnected = state =>
  selectBase(state).facebookConnected
